import React, { Children, cloneElement } from 'react'
import { node, shape, func, string } from 'prop-types'

export default function DynamicFlow({
  actions,
  onLoad,
  children,
  changePage,
  origin,
}) {
  const first = 0
  const last = children.length - 1
  const unique = !Array.isArray(children)

  const childrenArray = Children.toArray(children)

  const selectedIndexPage = childrenArray.findIndex(
    child => child.props.path === origin
  )

  if (selectedIndexPage === -1) {
    changePage(childrenArray[first].props.path)
    return <div />
  }

  function onPrevious() {
    changePage(childrenArray[selectedIndexPage - 1].props.path)
  }

  function onNext() {
    changePage(childrenArray[selectedIndexPage + 1].props.path)
  }

  function getChildActionsByIndex(index) {
    switch (index) {
      case first:
        return { onNext }
      case last:
        return { onPrevious }
      default:
        return { onPrevious, onNext }
    }
  }

  const childrenWithProps = unique
    ? [
        cloneElement(children, {
          actions: { ...actions, ...children.props.actions },
          onLoad: children.props.onLoad || onLoad,
          step: 1,
        }),
      ]
    : Children.map(children, (child, index) => {
        return cloneElement(child, {
          ...getChildActionsByIndex(index),
          actions: { ...actions, ...child.props.actions },
          onLoad: child.props.onLoad || onLoad,
          step: index + 1,
        })
      })

  return childrenWithProps[selectedIndexPage]
}

DynamicFlow.propTypes = {
  children: node.isRequired,
  actions: shape({}),
  onLoad: func,
  changePage: func.isRequired,
  origin: string,
}

DynamicFlow.defaultProps = {
  actions: {},
  onLoad: undefined,
  origin: undefined,
}
